import { ColumnDef } from '@tanstack/react-table'
import { GetPlayerClearTurnoverHistoryResponse } from '@/modules/manage-player/type'
import { formatDateTime } from '@/common/lib/utils'

export const columns: ColumnDef<
	GetPlayerClearTurnoverHistoryResponse['data'][0]
>[] = [
	{
		accessorKey: 'createdAt',
		header: 'วันที่',
		cell: ({ row }) => formatDateTime(row.original.createdAt),
	},
	{
		accessorKey: 'amount',
		header: 'จำนวนเงิน',
		cell: ({ row }) => row.original.amount.toFixed(2),
	},
]
